module.exports = __webpack_public_path__ + "img/icon-英语@2x.11613eb1.png";